import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import FullScreenIllustration from '../../../domain/entities/FullScreenIllustration';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexFullScreenIllustrationsSuccess: {
      const result = action.payload as PaginatedResult<FullScreenIllustration>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
